module.exports = "/_next/static/images/mw-43ff7ada6b139b810508eb328d0afb83.svg";